export const DASHBOARD_NAV_WIDTH = 240;
export const DASHBOARD_MAX_WIDTH = 1580;
export const DASHBOARD_MAX_WIDTH_BREAKPOINT = DASHBOARD_MAX_WIDTH + 48;
export const DASHBOARD_CONTENT_MAX_WIDTH = DASHBOARD_MAX_WIDTH - (DASHBOARD_NAV_WIDTH + 24 + 2);

export const PAGE_HEADER_HEIGHT = 50;
export const PAGE_MENU_BUTTON_SIZE = 44;
export const PAGE_HEADER_ROLE = 'shef-dashboard-header';
export const PAGE_HEADER_SELECTOR = `[data-role=${PAGE_HEADER_ROLE}]`;

export const PAGE_LAYOUT_CLASS = 'shef-dashboard-layout';
export const PAGE_LAYOUT_COLUMN_CLASS = 'shef-dashboard-layout-column';

export const GRID_CLASS = 'shef-dashboard-layout';
export const GRID_COLUMN_CLASS = 'shef-dashboard-layout-column';
